import { createAsyncThunk } from '@reduxjs/toolkit';
import axios, { AxiosResponse } from 'axios';

import { RootState } from '../..';
import constants from '../../../constants';
import { UserContext } from '../types';

const getContext = createAsyncThunk('api/get-context', async (_, thunkAPI) => {
  const state = thunkAPI.getState() as RootState;

  // update the Axios response to match the customer data format.
  let response: AxiosResponse<UserContext>;

  try {
    response = await axios.get(
      `${state.api.customerServiceUrl}${constants.endpoints.get.context}`,
      {
        withCredentials: true, // Ensure credentials are sent with the request.
      },
    );
  } catch (e: unknown) {
    return thunkAPI.rejectWithValue(e);
  }

  // return data from the response.
  return response.data;
});

export default getContext;
